import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { Breadcrumbs, Button, Container, Typography, Paper, Box, IconButton, Snackbar, Alert } from "@mui/material";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

const Admin: React.FC = () => {
  const navigate = useNavigate();
  const [showCopySuccess, setShowCopySuccess] = useState(false);
  const [copiedUrl, setCopiedUrl] = useState("");

  const playerUrls = [
    { label: "v2Arena プレイヤー", path: "/v2arena" },
    { label: "BrainChase プレイヤー", path: "/brainchase" },
    { label: "KACHIDOKI プレイヤー", path: "/sequence" },
    { label: "v3Arena プレイヤー", path: "/v3arena" },
    { label: "Battle Royale プレイヤー", path: "/battle-royale/player" },
  ];

  const copyToClipboard = (path: string) => {
    const fullUrl = `${window.location.origin}${path}`;
    navigator.clipboard.writeText(fullUrl).then(() => {
      setCopiedUrl(fullUrl);
      setShowCopySuccess(true);
    });
  };

  const manageRooms = () => {
    navigate(`/admin/v2room`);
  };
  const manageSet = () => {
    navigate("/admin/set");
  };

  return (
    <Container>
      <Breadcrumbs
        separator={<NavigateNextIcon fontSize="small" />}
        aria-label="breadcrumb"
      >
        <Typography key="3" color="text.primary">
          Admin
        </Typography>
      </Breadcrumbs>
      <Typography variant="h2" component="h1" gutterBottom>
        管理者メニュー
      </Typography>
      <Button onClick={manageSet} variant="contained" sx={{ mx: 2 }}>
        セット管理
      </Button>
      <Button onClick={manageRooms} variant="contained" sx={{ mx: 2 }}>
        v2ルーム管理
      </Button>
      <Button
        onClick={() => {
          navigate("/admin/brainchase");
        }}
        variant="contained"
        sx={{ mx: 2 }}
      >
        BrainChase管理
      </Button>
      <Button
        onClick={() => {
          navigate("/admin/sequence");
        }}
        variant="contained"
        sx={{ mx: 2 }}
      >
        KACHIDOKI管理
      </Button>
      <Button
        onClick={() => {
          navigate("/admin/v3/projects");
        }}
        variant="contained"
        sx={{ mx: 2 }}
      >
        v3Arena プロジェクト管理
      </Button>
      <Button
        onClick={() => {
          navigate("/admin/upload-take");
        }}
        variant="contained"
        color="secondary"
        sx={{ mx: 2 }}
      >
        takeセットアップロード
      </Button>
      <Button
        onClick={() => {
          navigate("/admin/view-take");
        }}
        variant="outlined"
        sx={{ mx: 2 }}
      >
        takeセット画像確認
      </Button>

      <Box sx={{ mt: 4 }}>
        <Typography variant="h4" component="h2" gutterBottom>
          プレイヤー用URL
        </Typography>
        <Paper sx={{ p: 2 }}>
          {playerUrls.map((item) => (
            <Box key={item.path} sx={{ display: "flex", alignItems: "center", mb: 1 }}>
              <Typography sx={{ flexGrow: 1 }}>
                <strong>{item.label}:</strong> {window.location.origin}{item.path}
              </Typography>
              <IconButton
                onClick={() => copyToClipboard(item.path)}
                size="small"
                sx={{ ml: 1 }}
              >
                <ContentCopyIcon fontSize="small" />
              </IconButton>
            </Box>
          ))}
        </Paper>
      </Box>

      <Snackbar
        open={showCopySuccess}
        autoHideDuration={2000}
        onClose={() => setShowCopySuccess(false)}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert onClose={() => setShowCopySuccess(false)} severity="success">
          URLをコピーしました: {copiedUrl}
        </Alert>
      </Snackbar>
    </Container>
  );
};

export default Admin;
